module.exports = __webpack_public_path__ + "MeetBrianAfter.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MeetBrianAfter.jpg
// module id = 846
// module chunks = 0